(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prolicious-main-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ── Filter toggle ──────────────────────────────────────────────────
  document.querySelectorAll('[data-prolicious-filter-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      if (!panel) return;
      var isOpen = !panel.hidden;
      panel.hidden = isOpen;
      panel.setAttribute('aria-hidden', isOpen);
      btn.setAttribute('aria-expanded', !isOpen);
    });
  });

  // ── Sort toggle ───────────────────────────────────────────────────
  document.querySelectorAll('[data-prolicious-sort-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var dropdownId = btn.getAttribute('aria-controls');
      var dropdown = document.getElementById(dropdownId);
      if (!dropdown) return;
      var isOpen = !dropdown.hidden;
      dropdown.hidden = isOpen;
      btn.setAttribute('aria-expanded', !isOpen);
    });
  });

  // ── Sort option click ─────────────────────────────────────────────
  document.querySelectorAll('[data-prolicious-sort-value]').forEach(function (li) {
    li.addEventListener('click', function () {
      var value = li.getAttribute('data-prolicious-sort-value');
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    });
  });

  // ── Close sort dropdown on outside click ──────────────────────────
  document.addEventListener('click', function () {
    document.querySelectorAll('.prolicious-sort-dropdown').forEach(function (dd) {
      dd.hidden = true;
    });
    document.querySelectorAll('[data-prolicious-sort-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
    });
  });

  // ── Apply filters ────────────────────────────────────────────────
  document.querySelectorAll('[data-prolicious-apply-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var url = new URL(window.location.href);
      // Remove existing filter params
      Array.from(url.searchParams.keys()).forEach(function (key) {
        if (key.startsWith('filter.')) url.searchParams.delete(key);
      });
      // Checked checkboxes
      document.querySelectorAll('.prolicious-filter-checkbox:checked').forEach(function (cb) {
        url.searchParams.append(cb.name, cb.value);
      });
      // Price range inputs
      document.querySelectorAll('.prolicious-filter-price-input').forEach(function (inp) {
        if (inp.value !== '') url.searchParams.set(inp.name, inp.value);
      });
      window.location.href = url.toString();
    });
  });

  // ── Custom Protein Sorting ────────────────────────────────────────
  function sortProductsByProtein() {
    var urlParams = new URLSearchParams(window.location.search);
    var sortBy = urlParams.get('sort_by');
    if (sortBy === 'protein-ascending' || sortBy === 'protein-descending') {
      var grid = document.querySelector('.prolicious-product-grid');
      if (grid) {
        var cards = Array.from(grid.querySelectorAll('.prolicious-card'));
        cards.sort(function (a, b) {
          var aProt = parseFloat(a.getAttribute('data-protein')) || 0;
          var bProt = parseFloat(b.getAttribute('data-protein')) || 0;
          return sortBy === 'protein-ascending' ? aProt - bProt : bProt - aProt;
        });
        cards.forEach(function (card) {
          grid.appendChild(card);
        });
      }
    }
  }
  // Sync master and mirror checkboxes
  function initMirrorFilters() {
    const masterCheckboxes = document.querySelectorAll('.master-checkbox');
    masterCheckboxes.forEach(master => {
      const label = master.dataset.mirrorLabel;
      const mirrors = document.querySelectorAll(`.mirror-checkbox[data-mirror-label="${label}"]`);
      
      let anyChecked = master.checked;
      mirrors.forEach(m => {
        if (m.checked) anyChecked = true;
      });
      
      if (anyChecked) {
        master.checked = true;
        mirrors.forEach(m => {
          m.checked = true;
        });
      }
      
      master.addEventListener('change', (e) => {
        mirrors.forEach(m => {
          m.checked = e.target.checked;
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      sortProductsByProtein();
      initMirrorFilters();
    });
  } else {
    sortProductsByProtein();
    initMirrorFilters();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["prolicious-pdp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initProliciousPDP(container) {
      var sectionId = container.dataset.sectionId;

      // Parse variants
      var variantsEl = document.getElementById('ProliciousPDPVariants-' + sectionId);
      var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

      // Elements
      var mainImages = container.querySelectorAll('.prolicious-pdp__main-img');
      var thumbs = container.querySelectorAll('.prolicious-pdp__thumb');
      var tiles = container.querySelectorAll('.prolicious-pdp__tile');
      var variantIdInput = container.querySelector('#ProliciousPDPVid-' + sectionId);
      var priceEl = container.querySelector('#ProliciousPDPPrice-' + sectionId);
      var comparePriceEl = container.querySelector('#ProliciousPDPComparePrice-' + sectionId);
      var saveBadgeEl = container.querySelector('#ProliciousPDPSaveBadge-' + sectionId);
      var qtyInput = container.querySelector('#ProliciousPDPQty-' + sectionId);
      var atcBtn = container.querySelector('#ProliciousPDPAtc-' + sectionId);
      var atcText = container.querySelector('#ProliciousPDPAtcText-' + sectionId);
      var pinInput = container.querySelector('#ProliciousPDPPin-' + sectionId);
      var pinBtn = container.querySelector('[data-pin-check="' + sectionId + '"]');
      var pinResult = container.querySelector('#ProliciousPDPPinResult-' + sectionId);

      // ── Gallery ──────────────────────────────────────────────────
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var imageId = thumb.dataset.thumbId;

          mainImages.forEach(function (img) {
            var show = img.dataset.imageId === imageId;
            img.style.display = show ? '' : 'none';
          });

          thumbs.forEach(function (t) {
            var active = t.dataset.thumbId === imageId;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
        });
      });

      // ── Variant Tiles ────────────────────────────────────────────
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          var variantId = parseInt(tile.dataset.variantId, 10);
          var value = tile.dataset.value;
          var variant = variants.find(function (v) { return v.id === variantId; });
          if (!variant) return;

          // Update tile active state in the same group
          var group = tile.closest('.prolicious-pdp__tiles');
          if (group) {
            group.querySelectorAll('.prolicious-pdp__tile').forEach(function (t) {
              var sel = t === tile;
              t.classList.toggle('is-selected', sel);
              var badge = t.querySelector('.prolicious-pdp__tile-badge');
              if (badge) badge.classList.toggle('is-selected', sel);
            });
          }

          // Tick the hidden radio
          var radio = tile.querySelector('.prolicious-pdp__tile-radio');
          if (radio) radio.checked = true;

          // Update option value label
          var optLabel = container.querySelector('.prolicious-pdp__option-val[data-option-name]');
          if (optLabel) optLabel.textContent = value;

          // Update variant id input
          if (variantIdInput) variantIdInput.value = variantId;

          // Update price display
          if (priceEl) priceEl.textContent = variant.price;

          var hasDiscount = variant.rawCompareAtPrice > variant.rawPrice;
          if (comparePriceEl) {
            comparePriceEl.textContent = variant.compareAtPrice;
            comparePriceEl.classList.toggle('is-hidden', !hasDiscount);
          }
          if (saveBadgeEl) {
            if (hasDiscount && variant.rawCompareAtPrice > 0) {
              var pct = Math.round((variant.rawCompareAtPrice - variant.rawPrice) / variant.rawCompareAtPrice * 100);
              saveBadgeEl.textContent = 'Save ' + pct + '%';
            }
            saveBadgeEl.classList.toggle('is-hidden', !hasDiscount);
          }

          // Update ATC button
          if (atcBtn) {
            atcBtn.disabled = !variant.available;
            atcBtn.setAttribute('aria-disabled', (!variant.available).toString());
          }
          if (atcText) {
            atcText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
          }
        });
      });

      // ── Quantity ─────────────────────────────────────────────────
      container.querySelectorAll('[data-qty-action]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var current = parseInt(qtyInput.value, 10) || 1;
          if (btn.dataset.qtyAction === 'increase') {
            qtyInput.value = current + 1;
          } else if (btn.dataset.qtyAction === 'decrease' && current > 1) {
            qtyInput.value = current - 1;
          }
        });
      });

      // ── Pincode Checker ──────────────────────────────────────────
      function showPinResult(msg, type) {
        if (!pinResult) return;
        pinResult.textContent = msg;
        pinResult.className = 'prolicious-pdp__pin-result prolicious-pdp__pin-result--' + type;
        pinResult.hidden = false;
      }

      function checkPincode() {
        if (!pinInput) return;
        var pin = pinInput.value.trim();
        if (!pin || pin.length !== 6 || !/^\d{6}$/.test(pin)) {
          showPinResult('Please enter a valid 6-digit pincode.', 'error');
          return;
        }
        showPinResult('Checking…', 'loading');
        setTimeout(function () {
          showPinResult('Delivery available to this pincode.', 'success');
        }, 800);
      }

      if (pinBtn) {
        pinBtn.addEventListener('click', checkPincode);
      }
      if (pinInput) {
        pinInput.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') checkPincode();
        });
      }
    }

    function init() {
      document.querySelectorAll('.prolicious-pdp').forEach(function (el) {
        initProliciousPDP(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // Support Shopify theme editor section reloads
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.prolicious-pdp');
      if (section) initProliciousPDP(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
